




















import Vue from 'vue';

// Assets
import AonLogo from '~/assets/img/aon.svg';
import HigheredEFMDLogo from '~/assets/img/highered_efmd.png';
import abiAd from '~/assets/img/aon/abi-ad.jpg';

export default Vue.extend({
    name: 'AssessmentFooter',
    data: () => ({
        aonLogo: AonLogo,
        higheredLogo: HigheredEFMDLogo,
        abiAd: abiAd,
    }),
});
